module.exports = __webpack_public_path__ + "img/kitsu-text.7ca71b95.svg";